import { Country, State, City } from 'country-state-city';

// Lazy-built lookup maps
let _countryByCode = null;
let _stateByKey = null;

const getCountryByCode = () => {
    if (!_countryByCode) {
        _countryByCode = {};
        for (const c of Country.getAllCountries()) {
            _countryByCode[c.isoCode] = c;
        }
    }
    return _countryByCode;
};

const getStateByKey = () => {
    if (!_stateByKey) {
        _stateByKey = {};
        for (const s of State.getAllStates()) {
            _stateByKey[`${s.countryCode}-${s.isoCode}`] = s;
        }
    }
    return _stateByKey;
};

const SEARCH_LIMIT = 50;

const searchCountries = (query = '') => {
    if (!query) return [];
    const q = query.toLowerCase();
    const results = [];
    for (const c of Country.getAllCountries()) {
        if (c.name.toLowerCase().includes(q)) {
            results.push({
                ...c,
                iso2: c.isoCode,
            });
            if (results.length >= SEARCH_LIMIT) break;
        }
    }
    return results;
};

const searchStates = (query = '') => {
    if (!query) return [];
    const q = query.toLowerCase();
    const countryByCode = getCountryByCode();
    const results = [];
    for (const s of State.getAllStates()) {
        if (s.name.toLowerCase().includes(q)) {
            const country = countryByCode[s.countryCode];
            results.push({
                ...s,
                stateCode: s.isoCode,
                countryName: country?.name ?? '',
            });
            if (results.length >= SEARCH_LIMIT) break;
        }
    }
    return results;
};

const searchCities = (query = '') => {
    if (!query) return [];
    const q = query.toLowerCase();
    const countryByCode = getCountryByCode();
    const stateByKey = getStateByKey();
    const results = [];
    for (const city of City.getAllCities()) {
        if (city.name.toLowerCase().includes(q)) {
            const country = countryByCode[city.countryCode];
            const state = stateByKey[`${city.countryCode}-${city.stateCode}`];
            results.push({
                ...city,
                countryName: country?.name ?? '',
                stateName: state?.name ?? '',
            });
            if (results.length >= SEARCH_LIMIT) break;
        }
    }
    return results;
};

export const CountryStateCity = {
    searchCountries,
    searchStates,
    searchCities,
};
